import { ChartDefinition } from "./chartVariations";
import { fgBarChart } from "./fgbarchart";
import { fgPieChart } from "./fgpiechart";
import { fgLineChart } from "./linechart";

// Preloaded chart templates

export function generateChart(
  chartDefinition: ChartDefinition,
  modelName,
  filterColumns,
): any {
  let template: any;
  template = fgPieChart(modelName);
 
  const pie = [
    "Pie_Chart",
    "Advanced_Pie_Chart",
    "Pie_Grid",
    "tree-map",
    "number-card",
    "gauge",
  ];

  const bar = [
    "Vertical_Bar_Chart",
    "Horizontal_Bar_Chart",
    "Grouped_Vertical_Bar_Chart",
    "Grouped_Horizontal_Bar_Chart",
    "Stacked_Vertical_Bar_Chart",
    "Stacked_Horizontal_Bar_Chart",
    "Normalized_Vertical_Bar_Chart",
    "Normalized_Horizontal_Bar_Chart",
  ];

  const line = [
    "line-chart",
    "polar-chart",
    "area-chart",
    "area-chart-stacked",
    "area-chart-normalized",
    "heat-map",
    "box-chart",
  ];
  // Inject dynamic configuration

  if (pie.includes(chartDefinition.selectedVariation)) {
    template.subtype = "pie";
  }
  if (bar.includes(chartDefinition.selectedVariation)) {
    template.subtype = "bar";
  }

  if (line.includes(chartDefinition.selectedVariation)) {
    template.subtype = "line";
  }
  template.isOptionChart = chartDefinition.selectedVariation;
  template.queryConfig.measureField = chartDefinition.measureField;
  template.queryConfig.dimensionField = chartDefinition.dimensionField;
  template.queryConfig.dateField = chartDefinition.dateField;
  // ? [{ name: chartDefinition.dateField }]
  // : [];
  template.queryConfig.measureFieldAggregation = chartDefinition.aggregation;

  template.name = chartDefinition.name;
  template.heading = chartDefinition.shortTitle;
  template.chartSubtype = chartDefinition.selectedVariation || "";
  template.isOptionChart = chartDefinition.selectedVariation || "";
  template.isXAxisLabel = chartDefinition.dimensionField
    .map((d) => d.name)
    .join(", ");
  template.isYAxisLabel = chartDefinition.measureField
    .map((m) => m.name)
    .join(", ");

  //console.log("Chart Component : ", template);
const filters  = filterColumns.map(f => ({
  targetFieldCode: f.name,
  conditionVal: f.name,
  condition: "equal",
  isDynamic: true
}));
  template.queryConfig.conditions = filters;
  return template;
}

export function generateDynamicChart(
  chartDefinition: ChartDefinition,
  modelName: string,
  filterColumns:any
): any {
  // Ensure there are variations available
  if (
    !chartDefinition.chartVariations ||
    !Array.isArray(chartDefinition.chartVariations) ||
    chartDefinition.chartVariations.length === 0
  ) {
    console.warn("No chartVariations found. Falling back to default.");
    return generateChart(chartDefinition, modelName, filterColumns);
  }

  // Randomly select one variation
  const randomIndex = Math.floor(Math.random() * chartDefinition.chartVariations.length);
  chartDefinition.selectedVariation = chartDefinition.chartVariations[randomIndex];

  // Delegate to existing function
  return generateChart(chartDefinition, modelName,filterColumns);
}